import { OPEN_SETTING } from "../constants/settingConstants";

export const openSettings = (isOpen) => (dispatch) => {
  console.log("asd", isOpen);
  dispatch({ type: OPEN_SETTING, payload: isOpen });
};
